export default {
  // 通用
  common: {
    avatar: '头像',
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    back: '返回',
    loading: '加载中...',
    noData: '暂无数据',
    success: '操作成功',
    error: '操作失败',
    logout: '退出登录',
    login: '登录',
    register: '注册',
    action: '操作',
    view: '查看',
    total: '共',
    items: '条记录',
    language: '语言',
    status: '状态',
    active: '启用',
    inactive: '禁用',
    createTime: '创建时间',
    updateTime: '更新时间',
    createUser: '创建用户',
    editUser: '编辑用户',
    password: '密码',
    confirmPassword: '确认密码',
    deleteConfirm: '确定要删除吗？',
    deleteSuccess: '删除成功',
    deleteError: '删除失败',
    createSuccess: '创建成功',
    createError: '创建失败',
    updateSuccess: '更新成功',
    updateError: '更新失败',
    loadError: '加载失败',
    invalidId: '无效的ID',
    languageRequired: '请选择语言',
    noImage: '无图片',
    upload: '上传',
    refresh: '刷新',
    refreshSuccess: '刷新成功',
    optional: '可选',
    yes: '是',
    no: '否',
    imageOnly: '只能上传图片文件',
    imageSizeLimit: '图片大小不能超过5MB',
    fileSizeLimit: '文件大小不能超过{size}MB',
    uploadSceneMissing: '请先完善必填项后再上传',
    totalItems: '共 {total} 条记录',
    previous: '上一篇',
    next: '下一篇',
    saveError: '保存失败'
  },

  // 时间格式
  datetime: {
    format: {
      full: 'yyyy-MM-dd HH:mm:ss',
      dateTime: 'yyyy-MM-dd HH:mm',
      date: 'yyyy-MM-dd',
      time: 'HH:mm:ss',
      monthDay: 'MM-dd',
      hourMinute: 'HH:mm'
    },
    weekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
  },

  // 导航
  nav: {
    dashboard: '仪表盘',
    bigScreen: '数据大屏',
    userManagement: '用户管理',
    roleManagement: '角色管理',
    permissionManagement: '权限管理',
    departmentManagement: '部门管理',
    systemManagement: '系统管理'
  },

  // 农业大屏
  agricultural: {
    title: '农业物联网监控大屏',
    weatherSensor: '气象传感器',
    soilSensor: '土壤传感器',
    deviceMap: '设备分布地图',
    temperature: '温度',
    humidity: '湿度',
    windSpeed: '风速',
    windDirection: '风向',
    rainfall: '雨量',
    lightIntensity: '光照度',
    soilTemperature: '土壤温度',
    soilHumidity: '土壤湿度',
    deviceStatus: '设备状态',
    online: '在线',
    offline: '离线',
    onlineDevices: '在线设备',
    offlineDevices: '离线设备',
    systemStatus: '系统状态',
    normalOperation: '正常运行',
    dataUpdate: '数据更新',
    totalDevices: '设备总数',
    deviceNorthArea: '设备 A - 农田北区',
    deviceSouthArea: '设备 B - 农田南区',
    trendChart: '24小时数据趋势',
    anhui: '安徽省农田设备分布',
    location: '位置',
    fullscreen: '全屏切换',
    lightTheme: '切换亮色主题',
    darkTheme: '切换暗色主题',
    returnDashboard: '返回Dashboard'
  },

  // 用户管理
  user: {
    title: '用户管理',
    list: '用户列表',
    create: '创建用户',
    edit: '编辑用户',
    username: '用户名',
    email: '邮箱',
    phone: '手机号',
    status: '状态',
    enabled: '启用',
    disabled: '禁用',
    department: '所属部门',
    createTime: '创建时间',
    updateTime: '更新时间',
    createUser: '创建用户',
    editUser: '编辑用户',
    password: '密码',
    confirmPassword: '确认密码',
    usernamePlaceholder: '请输入用户名',
    emailPlaceholder: '请输入邮箱',
    phonePlaceholder: '请输入手机号',
    passwordPlaceholder: '请输入密码',
    confirmPasswordPlaceholder: '请确认密码',
    statusPlaceholder: '请选择状态',
    departmentPlaceholder: '请选择部门',
    usernameRequired: '请输入用户名',
    emailRequired: '请输入邮箱',
    statusRequired: '请选择状态',
    departmentRequired: '请选择部门',
    usernameLength: '用户名长度在 3 到 20 个字符',
    emailInvalid: '请输入有效的邮箱地址',
    phoneInvalid: '请输入有效的手机号',
    passwordRequired: '请输入密码',
    passwordLength: '密码长度在 6 到 20 个字符',
    confirmPasswordRequired: '请确认密码',
    confirmPasswordMismatch: '两次输入的密码不一致',
    loadError: '加载用户信息失败',
    loadDepartmentError: '加载部门列表失败',
    updateSuccess: '用户更新成功',
    updateError: '更新失败'
  },

  // 鉴茄师管理
  appraiser: {
    title: '鉴茄师管理',
    list: '鉴茄师列表',
    edit: '编辑鉴茄师',
    appraiserId: '鉴茄师ID',
    customerId: '用户ID',
    realName: '姓名',
    realNamePlaceholder: '请输入姓名',
    realNameRequired: '请输入姓名',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    phoneRequired: '请输入手机号',
    phoneInvalid: '手机号格式不正确',
    weixin: '微信号',
    weixinPlaceholder: '请输入微信号',
    titleLevel: '头衔等级',
    titleLevelPlaceholder: '请选择',
    titleLevelIntern: '实习',
    titleLevelFormal: '正式',
    isWork: '可服务',
    isWorkPlaceholder: '请选择',
    teacher: '老师',
    teacherPlaceholder: '请选择老师',
    loadError: '加载鉴茄师列表失败',
    loadDetailError: '加载鉴茄师详情失败',
    loadTeachersError: '加载老师列表失败',
    updateSuccess: '更新成功',
    updateError: '更新失败'
  },

  sommelier: {
    title: '侍茄师管理',
    list: '侍茄师列表',
    sommelierId: '侍茄师ID',
    userId: '用户ID',
    realName: '姓名',
    realNamePlaceholder: '请输入姓名',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    weixin: '微信号',
    gender: '性别',
    birthday: '出生日期',
    address: '地址',
    levelId: '等级',
    isWork: '可服务',
    loadError: '加载侍茄师列表失败',
    upgradeTitle: '侍茄师等级变更',
    levelPlaceholder: '请选择等级',
    levelRequired: '请选择等级',
    loadDetailError: '加载侍茄师详情失败',
    upgradeSuccess: '等级变更成功',
    upgradeError: '等级变更失败'
  },

  sommelierLevel: {
    title: '侍茄师等级管理',
    create: '新增侍茄师等级',
    edit: '编辑侍茄师等级',
    levelId: '等级ID',
    name: '等级名称',
    namePlaceholder: '请输入等级名称',
    nameRequired: '请输入等级名称',
    levelRank: '等级权重',
    levelRankPlaceholder: '请输入等级权重',
    levelRankRequired: '请输入等级权重',
    servicePrice: '服务价格',
    servicePricePlaceholder: '请输入服务价格',
    servicePriceRequired: '请输入服务价格',
    description: '描述',
    descriptionPlaceholder: '请输入描述',
    statusPlaceholder: '请选择状态',
    loadError: '加载侍茄师等级失败',
    createSuccess: '创建侍茄师等级成功',
    createError: '创建侍茄师等级失败',
    updateSuccess: '更新侍茄师等级成功',
    updateError: '更新侍茄师等级失败'
  },

  // 用户互评标签字典管理
  tag: {
    title: '标签管理',
    create: '新增标签',
    edit: '编辑标签',
    id: '标签ID',
    name: '标签名称',
    namePlaceholder: '请输入标签名称',
    nameRequired: '请输入标签名称',
    type: '类别',
    typePlaceholder: '请选择类别',
    typeUser: '用户',
    typeNote: '帖子',
    typeComment: '评论',
    typeStore: '店铺',
    typeProduct: '商品',
    sentiment: '情感倾向',
    sentimentPlaceholder: '请选择情感倾向',
    sentimentPositive: '正面',
    sentimentNeutral: '中性',
    sentimentNegative: '负面',
    sort: '排序',
    sortPlaceholder: '数值越大越靠前',
    statusPlaceholder: '请选择状态',
    loadError: '加载标签失败',
    createSuccess: '创建标签成功',
    createError: '创建标签失败',
    updateSuccess: '更新标签成功',
    updateError: '更新标签失败',
    toggleSuccess: '状态更新成功',
    toggleError: '状态更新失败',
    deleteConfirm: '删除此标签后，将同步删除所有使用该标签的关联数据，且不可恢复。确认删除？',
    deleteSuccess: '删除标签成功',
    deleteError: '删除标签失败'
  },

  // 标签治理（按 user_id 查询）
  tagGov: {
    title: '标签治理',
    userId: '用户ID',
    userIdPlaceholder: '请输入用户ID(user_id)',
    userIdRequired: '请输入用户ID',
    query: '查询',
    tagName: '标签名称',
    count: '打标人数',
    remove: '移除',
    removeConfirm: '确认移除该用户的此标签吗？将删除该标签下的全部记录，不可恢复。',
    removeSuccess: '移除成功',
    removeError: '移除失败',
    loadError: '查询用户标签失败',
    empty: '该用户暂无标签'
  },

  // 帖子模板
  noteTemplate: {
    title: '模板管理',
    create: '新建模板',
    edit: '编辑模板',
    albumName: '风格名称',
    albumNamePlaceholder: '请输入风格名称',
    albumNameRequired: '请输入风格名称',
    status: '状态',
    statusPlaceholder: '请选择状态',
    statusDraft: '草稿',
    statusActive: '已启用',
    statusDisabled: '已禁用',
    statusArchived: '已归档',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    sortOrder: '排序',
    sortOrderPlaceholder: '请输入排序值（数字越小越靠前）',
    // 编辑器 Tab
    tabBasic: '基础信息',
    tabBackground: '背景图',
    tabFont: '字体配置',
    tabStyle: '样式配置',
    tabRender: '渲染配置',
    // 背景图
    coverBackground: '封面背景图',
    contentBackground: '正文背景图',
    backgroundHint: '建议尺寸与渲染画布一致（默认 1080×1440）',
    uploadHint: '点击上传',
    // 字体配置
    fontRefs: '字体引用',
    addFontRef: '添加字体引用',
    fontRole: '用途',
    fontRolePlaceholder: '请选择用途',
    fontAsset: '字体资产',
    fontAssetPlaceholder: '请选择字体',
    cssSelector: 'CSS选择器',
    cssSelectorPlaceholder: '如 .cover-title，留空按用途映射',
    fontFamilyAlias: '字体别名',
    fontSize: '字号',
    fontWeight: '字重',
    lineHeight: '行高',
    letterSpacing: '字间距',
    livePreview: '实时预览',
    fontRoleDuplicate: '字体用途不能重复',
    fontRoleRequired: '请为每行字体引用选择用途与字体',
    noFonts: '暂无字体引用，点击下方按钮添加',
    // 字体用途选项
    role_all: '全部',
    role_cover_title: '封面标题',
    role_cover_subtitle: '封面副标题',
    role_heading: '正文标题',
    role_body: '正文',
    role_quote: '引用',
    role_caption: '图注',
    role_footer: '页脚',
    role_watermark: '水印',
    // 样式配置
    canvasSection: '画布',
    canvasWidth: '画布宽度',
    canvasHeight: '画布高度',
    contentWidth: '正文宽度',
    marginsSection: '边距',
    marginTop: '上边距',
    marginRight: '右边距',
    marginBottom: '下边距',
    marginLeft: '左边距',
    colorsSection: '颜色',
    pageBackground: '页面背景色',
    textColor: '正文颜色',
    themeColor: '主题色',
    // 封面版式
    coverSection: '封面版式',
    titlePosition: '标题位置',
    dragHint: '在右侧封面预览中拖拽标题即可调整位置',
    showExcerpt: '显示正文摘要',
    excerptGap: '标题与正文间距',
    excerptLineHeight: '封面正文行间距',
    // 渲染配置
    outputFormat: '输出格式',
    outputQuality: '图片质量',
    // 预览
    tab_cover: '封面预览',
    tab_content: '正文预览',
    tab_source: '查看源代码',
    // 保存
    saveDraft: '保存草稿',
    publish: '发布模板',
    saveDraftSuccess: '草稿保存成功',
    publishSuccess: '模板发布成功',
    saveSuccess: '保存成功',
    saveError: '保存模板失败',
    loadError: '加载帖子模板失败',
    deleteConfirm: '删除此模板后不可恢复。确认删除？',
    deleteSuccess: '删除模板成功',
    deleteError: '删除模板失败'
  },

  // 字体资产
  fontAsset: {
    title: '字体管理',
    register: '上传字体',
    keyword: '关键词',
    keywordPlaceholder: '名称 / font-family',
    statusPlaceholder: '请选择状态',
    enabled: '可用',
    disabled: '禁用',
    enable: '启用',
    disable: '禁用',
    file: '字体文件',
    uploadHint: '选择字体文件（otf/ttf/woff/woff2）',
    fontName: '字体名称',
    fontNamePlaceholder: '如 SourceHanSerifSC-SemiBold',
    fontFamily: 'font-family',
    fontFamilyPlaceholder: '如 SourceHanSerifSC',
    fontWeight: '字重',
    fontStyle: '样式',
    fontFormat: '格式',
    fileSize: '大小',
    nameRequired: '请填写字体名称与 font-family',
    registerSuccess: '字体登记成功',
    registerError: '字体登记失败',
    deleteConfirm: '删除后模板将无法引用该字体。确认删除？',
    deleteSuccess: '删除字体成功',
    deleteError: '删除字体失败',
    loadError: '加载字体列表失败'
  },

  // 官方认证（大V）审核
  officialVerify: {
    title: '官方认证审核',
    reviewTitle: '审核官方认证申请',
    applicationId: '申请ID',
    userId: '用户ID',
    platform: '第三方平台',
    platformPlaceholder: '请输入平台名称',
    homeUrl: '主页链接',
    homepageShot: '主页截图',
    noShot: '暂无截图',
    remark: '补充说明',
    status: '状态',
    statusPlaceholder: '请选择状态',
    statusPending: '待审核',
    statusUnderReview: '审核中',
    statusApproved: '已通过',
    statusRejected: '已拒绝',
    statusCanceled: '已取消',
    submitAt: '提交时间',
    reviewAt: '审核时间',
    reviewReason: '审核说明',
    reviewReasonPlaceholder: '请输入审核说明（拒绝时必填）',
    reviewReasonRequired: '请填写拒绝原因',
    reviewButtonText: '审核',
    approve: '通过',
    reject: '拒绝',
    approveConfirm: '确认通过该官方认证申请？通过后用户将被标记为大V。',
    rejectConfirm: '确认拒绝该官方认证申请？',
    reviewSuccess: '审核成功',
    reviewError: '审核失败',
    revoke: '撤销认证',
    revokeConfirm: '撤销后将删除该用户全部官方认证申请记录并清除大V身份，不可恢复。确认撤销？',
    revokeSuccess: '撤销认证成功',
    revokeError: '撤销认证失败',
    loadError: '加载官方认证申请失败',
    loadDetailError: '加载申请详情失败'
  },

  // 官方号管理
  officialAccount: {
    title: '官方号管理',
    grantButton: '授予官方号',
    grantTitle: '授予官方号',
    grantConfirm: '确认授予',
    customerId: '用户 ID',
    customerIdPlaceholder: '请输入 customer_id',
    yashId: '雅号',
    yashIdPlaceholder: '请输入雅号',
    nickname: '昵称',
    nicknamePlaceholder: '请输入昵称',
    user: '用户',
    badge: '标识',
    badgeLabel: '官方账号',
    bigVLabel: '认证创作者',
    noBadge: '无认证',
    currentBadge: '当前认证',
    updatedAt: '更新时间',
    lookup: '查询用户',
    lookupRequired: '请填写用户 ID 或雅号',
    lookupError: '查询用户失败',
    grantTargetRequired: '请先查询并确认要授予的用户',
    grantSuccess: '授予官方号成功',
    grantError: '授予官方号失败',
    revoke: '撤销官方号',
    revokeConfirm: '撤销后该用户将不再显示官方号标识，确认撤销？',
    revokeSuccess: '撤销官方号成功',
    revokeError: '撤销官方号失败',
    loadError: '加载官方号列表失败'
  },

  // 鉴茄师申请管理
  appraiserApplication: {
    title: '鉴茄师申请审核',
    list: '鉴茄师申请列表',
    reviewButtonText: '审核',
    review: '审核鉴茄师申请',
    nickname: '昵称',
    nicknamePlaceholder: '请输入昵称',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    weixin: '微信号',
    city: '所在城市',
    cigarYear: '茄龄(年份)',
    status: '审核状态',
    statusPlaceholder: '请选择审核状态',
    statusPending: '待审',
    statusApproved: '通过',
    statusRejected: '拒绝',
    remark: '审核备注',
    remarkPlaceholder: '请输入审核备注',
    approve: '通过',
    reject: '拒绝',
    createdAt: '申请时间',
    auditedAt: '审核时间',
    loadError: '加载申请列表失败',
    loadDetailError: '加载申请详情失败',
    reviewSuccess: '审核成功',
    reviewError: '审核失败',
    approveConfirm: '确定要通过该申请吗？',
    rejectConfirm: '确定要拒绝该申请吗？',
    remarkRequired: '审核备注不能为空',
    teacher: '指导老师',
    teacherPlaceholder: '请选择指导老师',
    teacherRequired: '审核通过时必须指定指导老师'
  },

  sommelierApplication: {
    title: '侍茄师申请审核',
    list: '侍茄师申请列表',
    reviewButtonText: '审核',
    review: '审核侍茄师申请',
    realName: '姓名',
    realNamePlaceholder: '请输入姓名',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    weixin: '微信号',
    sex: '性别',
    sexMale: '男',
    sexFemale: '女',
    photoList: '侍茄师照片',
    certificateList: '资质证书',
    resumeList: '个人简历',
    provinceCode: '省份代码',
    cityCode: '城市代码',
    districtCode: '区县代码',
    address: '详细地址',
    status: '审核状态',
    statusPlaceholder: '请选择审核状态',
    statusPending: '待审',
    statusApproved: '通过',
    statusRejected: '拒绝',
    remark: '审核备注',
    remarkPlaceholder: '请输入审核备注（拒绝时必填）',
    approve: '通过',
    reject: '拒绝',
    createdAt: '申请时间',
    auditedAt: '审核时间',
    loadError: '加载申请列表失败',
    loadDetailError: '加载申请详情失败',
    reviewSuccess: '审核成功',
    reviewError: '审核失败',
    approveConfirm: '确定要通过该申请吗？',
    rejectConfirm: '确定要拒绝该申请吗？',
    remarkRequired: '拒绝申请时，审核备注不能为空',
    level: '侍茄师等级',
    levelPlaceholder: '请选择侍茄师等级',
    levelRequired: '审核通过时，必须指定侍茄师等级'
  },

  // 规格管理
  option: {
    title: '商品规格',
    create: '新增规格',
    edit: '编辑规格',
    update: '更新规格',
    optionId: '规格ID',
    name: '规格名称',
    type: '规格类型',
    values: '规格值',
    sortOrder: '排序',
    searchPlaceholder: '搜索规格名称',
    namePlaceholder: '请输入规格名称',
    typePlaceholder: '请选择规格类型',
    sortOrderPlaceholder: '请输入排序值',
    typeSelect: '下拉选择',
    typeRadio: '单选按钮',
    typeCheckbox: '多选框',
    addValue: '添加规格值',
    valueName: '规格值名称',
    valueImage: '规格值图片',
    noValues: '暂无规格值，点击"添加规格值"按钮添加',
    nameRequired: '请输入规格名称',
    typeRequired: '请选择规格类型',
    sortOrderRequired: '请输入排序值',
    createSuccess: '创建规格成功',
    createError: '创建规格失败',
    updateSuccess: '更新规格成功',
    updateError: '更新规格失败',
    deleteSuccess: '删除规格成功',
    deleteError: '删除规格失败',
    deleteConfirm: '确定要删除这个规格吗？',
    loadError: '加载规格数据失败'
  },

  // 帖子管理
  note: {
    title: '帖子管理',
    list: '帖子列表',
    create: '新增帖子',
    edit: '编辑帖子',
    detail: '帖子详情',
    id: 'ID',
    userId: '用户ID',
    noteTitle: '标题',
    type: '类型',
    category: '分类',
    description: '内容',
    location: '地址',
    longitude: '经度',
    latitude: '纬度',
    status: '状态',
    createTime: '创建时间',
    updateTime: '更新时间',
    typeNormal: '图文',
    typeVideo: '视频',
    category0: '推荐',
    category1: '鉴茄',
    category2: '约茄',
    category3: '茄友互助',
    category4: '线下茄吧',
    statusValid: '有效',
    statusInvalid: '无效',
    searchTitle: '搜索标题',
    selectType: '帖子类型',
    selectCategory: '帖子分类',
    userIdPlaceholder: '请输入用户ID',
    titlePlaceholder: '请输入帖子标题',
    descriptionPlaceholder: '请输入帖子内容',
    locationPlaceholder: '请输入地址',
    longitudePlaceholder: '请输入经度',
    latitudePlaceholder: '请输入纬度',
    userIdRequired: '请输入用户ID',
    titleRequired: '请输入标题',
    typeRequired: '请选择类型',
    categoryRequired: '请选择分类',
    descriptionRequired: '请输入内容',
    locationRequired: '请输入地址',
    statusRequired: '请选择状态',
    titleMaxLength: '标题最多255个字符',
    locationMaxLength: '地址最多255个字符',
    createSuccess: '创建成功',
    createError: '创建失败',
    updateSuccess: '更新成功',
    updateError: '更新失败',
    deleteSuccess: '删除成功',
    deleteError: '删除失败',
    deleteConfirm: '确定要删除这条帖子吗？',
    fetchError: '获取帖子列表失败',
    fetchDetailError: '获取帖子详情失败'
  },

  // 雪茄品牌管理
  // 品牌分类管理
  brandCategory: {
    title: '品牌分类',
    all: '全部',
    name: '名称',
    namePlaceholder: '请输入分类名称',
    nameRequired: '请输入分类名称',
    parent: '上级分类',
    parentPlaceholder: '不选择则创建顶级分类',
    description: '描述',
    descriptionPlaceholder: '请输入分类描述',
    sortOrder: '排序',
    sortOrderPlaceholder: '请输入排序值（数字越小越靠前）',
    addTitle: '添加分类',
    addChild: '增加子分类',
    addChildTitle: '添加子分类',
    editTitle: '编辑分类',
    createSuccess: '分类创建成功',
    updateSuccess: '分类更新成功',
    updateError: '分类更新失败',
    deleteConfirm: '确定要删除该分类吗？存在子分类或被品牌引用时无法删除。'
  },

  cigarBrand: {
    title: '雪茄品牌管理',
    list: '品牌列表',
    create: '新增品牌',
    edit: '编辑品牌',
    detail: '品牌详情',
    brandId: '品牌ID',
    sortOrder: '排序',
    sortOrderPlaceholder: '请输入排序值',
    code: '品牌编码',
    logo: '品牌Logo',
    codeRequiredBeforeLogo: '品牌编码（英文 slug）作为 Logo 的 OSS 目录 cigar_brands/{slug}/，请先填写品牌编码再上传',
    serie: '系列',
    seriePlaceholder: '请选择系列（可多选）',
    name: '品牌名称',
    nameCn: '品牌名称（中文）',
    nameEn: '品牌名称（英文）',
    description: '品牌描述',
    descriptionCn: '品牌描述（中文）',
    descriptionEn: '品牌描述（英文）',
    brandCategory: '品牌类别',
    brandCategoryPlaceholder: '请选择品牌类别',
    tabAll: '全部',
    country: '所属国家',
    countryCn: '所属国家（中文）',
    countryEn: '所属国家（英文）',
    factoryName: '工厂名称',
    factoryNamePlaceholder: '请输入工厂名称',
    genericName: '常用名',
    genericNamePlaceholder: '请输入常用名',
    status: '状态',
    statusActive: '启用',
    statusInactive: '禁用',
    languageId: '语言',
    languageCn: '中文',
    languageEn: '英文',
    searchPlaceholder: '搜索品牌名称或编码',
    codePlaceholder: '请输入品牌编码',
    namePlaceholder: '请输入品牌名称',
    descriptionPlaceholder: '请输入品牌描述',
    countryPlaceholder: '请选择所属国家',
    codeRequired: '请输入品牌编码',
    nameRequired: '请输入品牌名称',
    countryRequired: '请选择所属国家',
    countryCodeLength: '国家代码长度不能超过3个字符',
    createSuccess: '创建品牌成功',
    createError: '创建品牌失败',
    updateSuccess: '更新品牌成功',
    updateError: '更新品牌失败',
    categoryUpdateSuccess: '品牌分类已更新',
    dragToCategoryHint: '拖拽右侧品牌行到分类节点可修改分类',
    deleteSuccess: '删除品牌成功',
    deleteError: '删除品牌失败',
    deleteConfirm: '确定要删除这个品牌吗？',
    fetchError: '获取品牌列表失败',
    fetchDetailError: '获取品牌详情失败',
    uploadLogo: '上传Logo',
    multiLanguage: '多语言设置',
    basicInfo: '基本信息',
    languageVersionExtra: '切换语言可编辑对应语言版本的名称与描述；编码、分类、Logo、系列为各语言共享字段',
    switchLanguageConfirmTitle: '切换语言版本',
    switchLanguageConfirmContent: '当前语言版本存在未保存的修改，切换后修改将丢失，确定继续吗？',
    switchLanguageConfirmOk: '继续切换'
  },

  cigarRingBand: {
    title: '雪茄环标管理',
    list: '环标列表',
    create: '新增环标',
    edit: '编辑环标',
    tabsBasic: '基本信息',
    tabsRing: '环标信息',
    add: '添加环标',
    ringName: '环标名称',
    ringNamePlaceholder: '请输入环标名称',
    ringNameRequired: '请输入环标名称',
    image: '环标图片',
    imageRequired: '请上传环标图片',
    periodDesc: '使用期限',
    periodDescPlaceholder: '请输入使用期限描述，例如：2016年-使用至今',
    startYear: '起始年份',
    startYearPlaceholder: '请输入起始年份',
    endYear: '结束年份',
    endYearPlaceholder: '请输入结束年份，9999 表示至今',
    present: '至今',
    yearRangeError: '结束年份不能早于起始年份',
    brandId: '所属品牌',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    createSuccess: '创建环标成功',
    createError: '创建环标失败',
    updateSuccess: '更新环标成功',
    updateError: '更新环标失败',
    deleteSuccess: '删除环标成功',
    deleteError: '删除环标失败',
    deleteConfirm: '确定要删除这个环标吗？',
    loadError: '加载环标数据失败'
  },

  // 雪茄系列管理
  cigarSerie: {
    title: '雪茄系列管理',
    list: '系列列表',
    create: '新增系列',
    edit: '编辑系列',
    detail: '系列详情',
    serieId: '系列',
    brandId: '品牌',
    brand: '所属品牌',
    code: '系列编码',
    name: '系列名称',
    description: '系列描述',
    sortOrder: '排序',
    brandPlaceholder: '请选择所属品牌',
    codePlaceholder: '请输入系列编码',
    namePlaceholder: '请输入系列名称',
    descriptionPlaceholder: '请输入系列描述',
    sortOrderPlaceholder: '请输入排序值',
    brandRequired: '请选择所属品牌',
    codeRequired: '请输入系列编码',
    nameRequired: '请输入系列名称',
    codeLength: '系列编码长度应在2-64个字符之间',
    nameLength: '系列名称长度应在2-255个字符之间',
    createSuccess: '创建系列成功',
    createError: '创建系列失败',
    updateSuccess: '更新系列成功',
    updateError: '更新系列失败',
    deleteSuccess: '删除系列成功',
    deleteError: '删除系列失败',
    deleteConfirm: '确定要删除这个系列吗？',
    fetchError: '获取系列列表失败',
    fetchDetailError: '获取系列详情失败',
    loadError: '加载系列数据失败'
  },

  // 雪茄通用名管理
  cigarCommonName: {
    title: '雪茄通用名管理',
    list: '通用名列表',
    create: '新增通用名',
    edit: '编辑通用名',
    detail: '通用名详情',
    name: '通用名',
    sortOrder: '排序',
    namePlaceholder: '请输入通用名',
    sortOrderPlaceholder: '请输入排序值（数字越小越靠前）',
    nameRequired: '请输入通用名',
    nameLength: '通用名长度应在1-255个字符之间',
    createSuccess: '创建通用名成功',
    createError: '创建通用名失败',
    updateSuccess: '更新通用名成功',
    updateError: '更新通用名失败',
    deleteSuccess: '删除通用名成功',
    deleteError: '删除通用名失败',
    deleteConfirm: '确定要删除这个通用名吗？被雪茄引用时将无法删除。',
    loadError: '加载通用名数据失败'
  },

  // 雪茄厂用名管理
  cigarFactoryVitola: {
    title: '雪茄厂用名管理',
    list: '厂用名列表',
    create: '新增厂用名',
    edit: '编辑厂用名',
    detail: '厂用名详情',
    name: '厂用名',
    sortOrder: '排序',
    namePlaceholder: '请输入厂用名',
    sortOrderPlaceholder: '请输入排序值（数字越小越靠前）',
    nameRequired: '请输入厂用名',
    nameLength: '厂用名长度应在1-255个字符之间',
    createSuccess: '创建厂用名成功',
    createError: '创建厂用名失败',
    updateSuccess: '更新厂用名成功',
    updateError: '更新厂用名失败',
    deleteSuccess: '删除厂用名成功',
    deleteError: '删除厂用名失败',
    deleteConfirm: '确定要删除这个厂用名吗？被雪茄引用时将无法删除。',
    loadError: '加载厂用名数据失败'
  },

  // 雪茄管理
  cigar: {
    title: '雪茄管理',
    list: '雪茄列表',
    create: '新增雪茄',
    edit: '编辑雪茄',
    detail: '雪茄详情',
    cigarId: '雪茄',
    brand: '品牌',
    brandPlaceholder: '请选择品牌',
    serie: '系列',
    serieId: '系列',
    name: '雪茄名称',
    /** 列表页列头/搜索标签 */
    listName: '雪茄名称',
    code: '产品编码',
    /** 列表页 SKU 列：展示 cj_cigar.code */
    sku: 'SKU',
    skuPlaceholder: '请输入 SKU',
    price: '价格',
    currency: '货币',
    length: '长度',
    ringGauge: '环径',
    weight: '重量',
    defaultPackId: '默认包装ID',
    strength: '强度',
    sortOrder: '排序',
    mainImage: '主图',
    image: '图片',
    filterTreeAll: '全部品牌',
    serieRelationDeleteConfirm: '确定从该品牌下移除此系列关联吗？仅解除关联，不会删除系列本身。',
    serieRelationDeleteSuccess: '移除系列关联成功',
    serieRelationDeleteError: '移除系列关联失败',
    dragImageHint: '拖拽上传',
    dragImageOnly: '仅支持拖拽图片文件',
    dragImageUploadSuccess: '图片追加成功',
    dragImageUploadFailed: '图片追加失败',
    startYear: '生产年份',
    endYear: '停产年份',
    releaseYear: '发行年份',
    status: '状态',
    factoryName: '工厂名称',
    commonName: '通用名称',
    region: '地区限定',
    regionPlaceholder: '请选择地区限定',
    description: '描述',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    statusInProduction: '在产',
    statusDiscontinued: '停产',
    namePlaceholder: '请输入雪茄名称',
    codePlaceholder: '请输入产品编码',
    serieIdPlaceholder: '请输入系列ID',
    pricePlaceholder: '请输入价格',
    currencyPlaceholder: '如 CNY、USD',
    lengthPlaceholder: '请输入长度(mm)',
    ringGaugePlaceholder: '请输入环径',
    weightPlaceholder: '请输入重量(g)',
    defaultPackIdPlaceholder: '请输入默认包装ID',
    strengthPlaceholder: '请输入强度(0-10)',
    sortOrderPlaceholder: '请输入排序值(越小越靠前)',
    statusPlaceholder: '请选择状态',
    factoryNamePlaceholder: '请输入工厂名称',
    commonNamePlaceholder: '请输入通用名称',
    descriptionPlaceholder: '请输入描述',
    nameRequired: '请输入雪茄名称',
    codeRequired: '请输入产品编码',
    codeLength: '产品编码长度应在2-64个字符之间',
    createSuccess: '创建雪茄成功',
    createError: '创建雪茄失败',
    updateSuccess: '更新雪茄成功',
    updateError: '更新雪茄失败',
    deleteSuccess: '删除雪茄成功',
    deleteError: '删除雪茄失败',
    deleteConfirm: '确定要删除这个雪茄吗？',
    fetchError: '获取雪茄列表失败',
    fetchDetailError: '获取雪茄详情失败',
    loadError: '加载雪茄数据失败',
    // 新建/编辑页分区卡片标题
    sectionBasicInfo: '基本信息',
    sectionSpecs: '规格参数',
    sectionDescription: '详情描述',
    yearInfo: '年份信息',
    // 图片语义槽位（顺序与导入链路「文件序号 → 图片类型」约定一致）
    images: '雪茄图片',
    imageSlotSerieLogo: '系列logo',
    imageSlotOpenBox: '盒子打开的照片',
    imageSlotCloseup: '单只雪茄整体特写',
    imageSlotBox: '盒子盖上的照片',
    imageSlotOthers: '其他照片'
  },

  // 雪茄 Excel 数据导入
  cigarImport: {
    title: '雪茄数据导入',
    taskList: '导入任务列表',
    upload: '上传Excel',
    chooseFile: '点击或拖拽 .xlsx 文件到此处上传',
    supportXlsx: '仅支持 .xlsx 格式',
    sizeLimit: '单文件不超过 {size}MB',
    onlyXlsx: '仅支持 .xlsx 格式文件',
    uploadSuccess: '上传成功，任务已排队',
    uploadFailed: '上传失败',
    taskId: '任务ID',
    fileName: '文件名',
    status: '状态',
    pending: '排队中',
    running: '处理中',
    success: '成功',
    failed: '失败',
    cancelled: '已取消',
    cancelTask: '取消任务',
    cancelConfirm: '确定取消该导入任务吗？正在处理的行可能已写入，无法回滚。',
    cancelSuccess: '取消成功',
    cancelFailed: '取消失败',
    totalRows: '总行数',
    processedRows: '已处理',
    successRows: '成功',
    skippedRows: '跳过',
    failedRows: '失败',
    errorDetail: '错误明细',
    row: '行号',
    column: '列',
    message: '错误信息',
    viewProgress: '查看进度',
    createdAt: '创建时间',
    brandType: '导入类别',
    brandTypePlaceholder: '请选择导入类别',
    brandTypeRequired: '请先选择导入类别',
    brandTypeChina: '中国',
    brandTypeCuba: '古巴',
    brandTypeNonCuban: '非古',
    stepBrandType: '选择类别',
    stepBrandTypeDesc: '请选择本次要导入的雪茄品牌类别',
    stepFile: '选择文件',
    stepFileDesc: '请选择需要导入的 Excel 文件（.xlsx）',
    stepProgress: '导入进度',
    prev: '上一步',
    next: '下一步',
    startNew: '导入新文件',
    subtitle: '通过Excel模板快速导入雪茄库数据，请选择对应的模板进行导入。',
    catChinaTitle: '国产雪茄导入',
    catChinaDesc: '支持长城、王冠等国产雪茄数据导入',
    catCubaTitle: '古巴雪茄导入',
    catCubaDesc: '支持高希霸、蒙特等古巴雪茄数据导入',
    catNonCubanTitle: '非古雪茄导入',
    catNonCubanDesc: '支持大卫杜夫、帕德龙等非古雪茄数据导入',
    downloadTemplate: '下载Excel模板',
    downloadTemplateDisabled: '模板下载暂未开放，请联系管理员获取',
    uploadHint: '点击或拖拽文件到此处上传',
    uploadHintSub: '支持 .xlsx 格式文件，单次最多导入 5000 条数据',
    // 不同品牌类别模板的列数 / 示例列，用于上传前提示用户校对文件结构
    templateCubanHint: '本模板包含 25 列：品牌 / 系列 / 地区 / 款型 / SKU / 厂名 / 通用名 / 尺寸 / 价格 / 产品介绍 等',
    templateChinaHint: '本模板包含 22 列：品牌 / 系列 / 款型 / 雪茄名称 / SKU / 厂名 / 通用名 / 尺寸 / 重量 / 官价(人民币) / 产品介绍 等',
    templateNonCubanHint: '本模板包含 23 列：品牌 / 系列 / 雪茄名称 / SKU / 通用名 / 长度 / 环径 / 茄衣 / 茄套 / 茄芯 / 工艺 / 调配师 / 原产国',
    wrongCategoryForNonCubanFile: '文件名似为非古雪茄数据，请先点击「非古雪茄导入」卡片再上传'
  },

  // 鉴茄图片规则管理
  cigarIdentify: {
    title: '雪茄鉴定规则',
    list: '规则列表',
    create: '新增规则',
    edit: '编辑规则',
    ruleId: '规则ID',
    code: '规则编码',
    codePlaceholder: '请输入规则编码',
    codeRequired: '请输入规则编码',
    name: '规则名称',
    namePlaceholder: '请输入规则名称',
    exampleImage: '示例图片',
    requiredLevel: '必填级别',
    requiredLevelPlaceholder: '请选择必填级别',
    requiredLevelRequired: '必填级别不能为空',
    requiredLevelOptional: '可选',
    requiredLevelRequiredValue: '必须',
    requiredLevelRecommended: '推荐',
    description: '描述',
    descriptionPlaceholder: '请输入描述',
    enabled: '启用状态',
    sortOrder: '排序',
    sortOrderPlaceholder: '请输入排序值',
    createdAt: '创建时间',
    searchPlaceholder: '搜索规则名称',
    loadError: '加载规则列表失败',
    createSuccess: '创建规则成功',
    createError: '创建规则失败',
    updateSuccess: '更新规则成功',
    updateError: '更新规则失败'
  },

  // 虚拟道具管理
  virtualItem: {
    title: '虚拟道具管理',
    list: '道具列表',
    create: '新增道具',
    edit: '编辑道具',
    itemId: '道具ID',
    code: '道具编码',
    itemType: '道具类型',
    name: '道具名称',
    icon: '图标',
    defaultDurationDays: '默认有效期(天)',
    status: '状态',
    itemTypeAvatarFrame: '头像框',
    itemTypeCommentBg: '评论背景',
    itemTypeEmoji: '表情',
    codePlaceholder: '请输入道具编码',
    namePlaceholder: '请输入道具名称',
    itemTypePlaceholder: '请选择道具类型',
    imageIdPlaceholder: '请输入图标附件ID',
    defaultDurationDaysPlaceholder: '请输入默认有效期天数',
    codeRequired: '请输入道具编码',
    nameRequired: '请输入道具名称',
    itemTypeRequired: '请选择道具类型',
    defaultDurationDaysRequired: '请输入默认有效期',
    defaultDurationDaysMin: '默认有效期必须大于0',
    statusRequired: '请选择状态',
    createSuccess: '创建道具成功',
    createError: '创建道具失败',
    updateSuccess: '更新道具成功',
    updateError: '更新道具失败',
    deleteSuccess: '删除道具成功',
    deleteError: '删除道具失败',
    deleteConfirm: '确定要删除这个道具吗？',
    loadError: '加载道具列表失败'
  },

  // 愿望单管理
  wishlist: {
    title: '愿望单管理',
    customer: '用户',
    customerId: '用户ID',
    customerIdPlaceholder: '请输入用户ID',
    target: '愿望实体',
    targetId: '实体ID',
    targetIdPlaceholder: '请输入实体ID',
    type: '类型',
    typePlaceholder: '请选择类型',
    typeProduct: '商品',
    typeCigar: '雪茄',
    sortOrder: '排序',
    statusPlaceholder: '请选择状态',
    statusActive: '有效',
    statusCancelled: '取消',
    cancelAt: '取消时间',
    saveSort: '保存排序',
    restore: '恢复',
    cancelWishlist: '取消',
    cancelConfirm: '确定要取消这条愿望单记录吗？',
    loadError: '加载愿望单失败',
    updateSuccess: '更新愿望单成功',
    updateError: '更新愿望单失败',
    restoreSuccess: '恢复愿望单成功',
    cancelSuccess: '取消愿望单成功',
    cancelError: '取消愿望单失败'
  },

  // 题目管理
  question: {
    headerTitle: '题目管理',
    title: '标题',
    list: '题目列表',
    create: '新增题目',
    edit: '编辑题目',
    titlePlaceholder: '请输入题目',
    titleRequired: '请输入题目',
    type: '题目类型',
    typePlaceholder: '请选择题目类型',
    typeRequired: '请选择题目类型',
    typeSingle: '单选题',
    typeMulti: '多选题',
    typeJudge: '判断题',
    difficulty: '难度',
    difficultyRequired: '请选择难度',
    analysis: '答案解析',
    analysisPlaceholder: '请输入答案解析',
    options: '选项',
    optionKeyPlaceholder: '选项键',
    optionContentPlaceholder: '请输入选项内容',
    optionContentRequired: '选项内容不能为空',
    isCorrect: '正确答案',
    addOption: '添加选项',
    optionsMinRequired: '至少需要2个选项',
    atLeastOneCorrectRequired: '至少需要一个正确答案',
    optionKeyDuplicate: '选项键不能重复',
    true: '正确',
    false: '错误',
    createSuccess: '创建题目成功',
    createError: '创建题目失败',
    updateSuccess: '更新题目成功',
    updateError: '更新题目失败',
    loadError: '加载题目失败',
    notFound: '题目不存在'
  },

  // 话题管理
  topic: {
    headerTitle: '话题管理',
    name: '名称',
    create: '新增话题',
    edit: '编辑话题',
    namePlaceholder: '请输入话题名称',
    nameRequired: '请输入话题名称',
    nameMaxLength: '名称长度不能超过255个字符',
    type: '类型',
    typePlaceholder: '请选择类型',
    typeRequired: '请选择类型',
    typePost: '帖子',
    typeWiki: '百科',
    hotTopic: '是否热门',
    hotTopicYes: '热门',
    hotTopicNo: '非热门',
    discussNum: '讨论数',
    discussNumPlaceholder: '请输入讨论数',
    enabled: '是否启用',
    enabledYes: '启用',
    enabledNo: '禁用',
    yes: '是',
    no: '否',
    createSuccess: '创建话题成功',
    createError: '创建话题失败',
    updateSuccess: '更新话题成功',
    updateError: '更新话题失败',
    loadError: '加载话题列表失败',
    loadDetailError: '加载话题失败',
    notFound: '话题不存在',
    deleteError: '删除话题失败'
  },

  // 数据字典管理
  dict: {
    title: '数据字典管理',
    list: '字典列表',
    create: '创建字典',
    edit: '编辑字典',
    code: '编码',
    name: '名称',
    description: '描述',
    searchPlaceholder: '请输入搜索内容',
    codePlaceholder: '请输入字典编码',
    namePlaceholder: '请输入字典名称',
    descriptionPlaceholder: '请输入字典描述',
    view: '查看',
    delete: '删除',
    codeRequired: '请输入字典编码',
    nameRequired: '请输入字典名称',
    basicInfo: '基本信息',
    dictItems: '数据字典',
    nextStep: '下一步',
    prevStep: '上一步',
    addNew: '新增',
    valueCode: '值编码',
    valueName: '值名称',
    valueCodePlaceholder: '请输入',
    valueNamePlaceholder: '请输入',
    moveUp: '上移',
    moveDown: '下移',
    itemValidationError: '请填写完整的字典项信息',
    createSuccess: '创建字典成功',
    createError: '创建字典失败',
    updateSuccess: '更新字典成功',
    updateError: '更新字典失败',
    deleteSuccess: '删除字典成功',
    deleteError: '删除字典失败',
    deleteConfirm: '确定要删除这个字典吗？',
    fetchError: '获取字典列表失败',
    fetchDetailError: '获取字典详情失败'
  },

  // 角色管理
  role: {
    title: '角色管理',
    list: '角色列表',
    create: '创建角色',
    edit: '编辑角色',
    name: '角色名称',
    code: '角色代码',
    description: '描述',
    permissions: '权限',
    enabled: '启用',
    disabled: '禁用',
    searchPlaceholder: '搜索角色...',
    statusPlaceholder: '状态',
    namePlaceholder: '请输入角色名称',
    codePlaceholder: '请输入角色代码',
    descriptionPlaceholder: '请输入描述',
    nameRequired: '请输入角色名称',
    nameLength: '角色名称长度在 2 到 50 个字符',
    codeRequired: '请输入角色代码',
    codeInvalid: '角色代码只能包含大写字母和下划线',
    createSuccess: '创建角色成功',
    createError: '创建角色失败',
    updateSuccess: '更新角色成功',
    updateError: '更新角色失败',
    deleteSuccess: '删除角色成功',
    deleteError: '删除角色失败',
    deleteConfirm: '确定要删除这个角色吗？',
    loadError: '加载角色列表失败',
    assignPermissions: '分配权限',
    permissionsTitle: '权限分配',
    user: '用户',
    assignRoles: '分配角色',
    rolesTitle: '角色分配',
    assignPermissionsPage: {
      title: '为角色分配权限',
      saveChanges: '保存更改',
      resourceGroups: '资源组',
      modulePermissions: '{name}权限',
      resourcePrefix: '资源: {code}',
      direct: '直接',
      inherited: '继承',
      selectAll: '全选',
      clearAll: '清空',
      expandAll: '展开全部',
      collapseAll: '收起全部',
      filterPlaceholder: '过滤权限...',
      selectedCount: '已选 {checked} / {total} 项',
      empty: '暂无可分配的权限',
      filterEmpty: '没有匹配的权限',
      selectModuleHint: '请从左侧选择资源模块',
      loadError: '加载权限数据失败',
      saveSuccess: '保存角色权限成功',
      saveError: '保存角色权限失败',
      invalidRole: '角色ID无效',
      columnName: '权限名称',
      columnCode: '代码 / 动作',
      columnType: '类型',
      columnDescription: '描述'
    }
  },

  // 权限管理
  permission: {
    title: '权限管理',
    list: '权限列表',
    create: '创建权限',
    edit: '编辑权限',
    name: '权限名称',
    code: '权限代码',
    description: '描述',
    resource: '资源名称',
    resourceCode: '资源代码',
    action: '操作',
    enabled: '启用',
    disabled: '禁用',
    searchPlaceholder: '搜索权限...',
    resourcePlaceholder: '资源',
    statusPlaceholder: '状态',
    namePlaceholder: '请输入权限名称',
    codePlaceholder: '请输入权限代码',
    descriptionPlaceholder: '请输入描述',
    resourcePlaceholderInput: '请输入资源名称',
    resourceCodePlaceholder: '请输入或选择资源代码',
    actionPlaceholder: '请输入操作',
    nameRequired: '请输入权限名称',
    nameLength: '权限名称长度在 2 到 50 个字符',
    codeRequired: '请输入权限代码',
    resourceRequired: '请输入资源名称',
    resourceCodeRequired: '请输入资源代码',
    actionRequired: '请输入操作',
    createSuccess: '创建权限成功',
    createError: '创建权限失败',
    updateSuccess: '更新权限成功',
    updateError: '更新权限失败',
    deleteSuccess: '删除权限成功',
    deleteError: '删除权限失败',
    deleteConfirm: '确定要删除这个权限吗？',
    loadError: '加载权限列表失败'
  },

  // 政策条款管理
  policy: {
    title: '政策条款管理',
    list: '政策条款列表',
    create: '创建政策条款',
    edit: '编辑政策条款',
    titleLabel: '标题',
    code: '编码',
    accessUrl: '访问URL',
    copyUrl: '复制访问URL',
    copySuccess: '访问URL已复制到剪贴板',
    copyError: '复制失败，请手动复制',
    content: '正文内容',
    titlePlaceholder: '请输入标题',
    codePlaceholder: '请输入编码',
    contentPlaceholder: '请输入正文内容',
    titleRequired: '请输入标题',
    codeRequired: '请输入编码',
    contentRequired: '请输入正文内容',
    titleMaxLength: '标题长度不能超过255个字符',
    codeMaxLength: '编码长度不能超过32个字符',
    loadError: '加载政策条款信息失败',
    createSuccess: '创建政策条款成功',
    createError: '创建政策条款失败',
    updateSuccess: '更新政策条款成功',
    updateError: '更新政策条款失败',
    deleteSuccess: '删除政策条款成功',
    deleteError: '删除政策条款失败'
  },

  // 举报分类管理
  reportCategory: {
    title: '举报分类管理',
    create: '新建举报分类',
    edit: '编辑举报分类',
    name: '分类名称',
    targetType: '适用类型',
    sortOrder: '排序',
    parentId: '父级ID',
    namePlaceholder: '请输入分类名称',
    targetTypePlaceholder: '请选择适用类型',
    statusPlaceholder: '请选择状态',
    parentIdPlaceholder: '0 为一级分类',
    nameRequired: '请输入分类名称',
    targetTypeRequired: '请选择适用类型',
    isActiveRequired: '请选择是否启用',
    targetTypeAll: '全部',
    targetTypeUser: '用户',
    targetTypeNote: '帖子',
    targetTypeComment: '评论'
  },

  // 举报记录管理
  reportRecord: {
    title: '举报记录',
    targetId: '被举报对象ID',
    targetUserId: '被举报作者ID',
    targetType: '类型',
    categoryId: '举报分类ID',
    categoryName: '举报分类',
    categoryTargetType: '分类适用类型',
    description: '描述',
    reporterId: '举报人ID',
    targetIdPlaceholder: '被举报对象ID',
    reporterIdPlaceholder: '举报人ID',
    targetTypePlaceholder: '类型',
    categoryIdPlaceholder: '举报分类ID'
  },

  // 部门管理
  department: {
    title: '部门管理',
    list: '部门列表',
    create: '创建部门',
    edit: '编辑部门',
    addChild: '添加子部门',
    name: '部门名称',
    code: '部门代码',
    parent: '上级部门',
    leader: '负责人',
    phone: '联系电话',
    email: '邮箱',
    orderNum: '排序',
    description: '描述',
    enabled: '启用',
    disabled: '禁用',
    tree: '部门树',
    detail: '部门详情',
    parentPlaceholder: '请选择上级部门',
    namePlaceholder: '请输入部门名称',
    codePlaceholder: '请输入部门代码',
    leaderPlaceholder: '请输入负责人',
    phonePlaceholder: '请输入联系电话',
    emailPlaceholder: '请输入邮箱',
    orderNumPlaceholder: '请输入排序值',
    descriptionPlaceholder: '请输入描述',
    noParent: '无',
    notSet: '未设置',
    nameRequired: '请输入部门名称',
    codeRequired: '请输入部门代码',
    createSuccess: '创建部门成功',
    createError: '创建部门失败',
    updateSuccess: '更新部门成功',
    updateError: '更新部门失败',
    deleteSuccess: '删除部门成功',
    deleteError: '删除部门失败',
    deleteConfirm: '确定要删除这个部门吗？',
    cannotDeleteWithChildren: '不能删除有子部门的部门',
    loadError: '加载部门树失败',
    loadChildrenError: '加载子部门失败'
  },

  // 行政区划管理
  division: {
    title: '行政区划管理',
    list: '行政区划列表',
    create: '创建行政区划',
    edit: '编辑行政区划',
    name: '名称',
    shortName: '简称',
    mergerName: '组合名',
    id: '行政编码',
    code: '行政代码',
    parentCode: '父级行政代码',
    level: '层级',
    level1: '省级/直辖市',
    level2: '地级市',
    level3: '区县',
    level4: '街道/乡镇',
    level5: '社区/村',
    cityCode: '城市代码',
    zipCode: '邮政编码',
    pinyin: '拼音',
    lng: '经度',
    lat: '纬度',
    sortOrder: '排序',
    namePlaceholder: '请输入名称',
    shortNamePlaceholder: '请输入简称',
    mergerNamePlaceholder: '请输入组合名',
    idPlaceholder: '请输入行政编码（12位数字）',
    codePlaceholder: '请输入行政代码',
    parentCodePlaceholder: '请输入父级行政代码（顶级可为空）',
    levelPlaceholder: '请选择层级',
    cityCodePlaceholder: '请输入城市代码',
    zipCodePlaceholder: '请输入邮政编码',
    pinyinPlaceholder: '请输入拼音',
    lngPlaceholder: '请输入经度',
    latPlaceholder: '请输入纬度',
    sortOrderPlaceholder: '请输入排序值',
    nameRequired: '请输入名称',
    idRequired: '请输入行政编码',
    idInvalid: '行政编码只能包含数字',
    idMaxLength: '行政编码最多12位数字',
    codeRequired: '请输入行政代码',
    levelRequired: '请选择层级',
    levelRange: '层级必须在1-5之间',
    codeInvalid: '行政代码必须是数字',
    createSuccess: '创建行政区划成功',
    createError: '创建行政区划失败',
    updateSuccess: '更新行政区划成功',
    updateError: '更新行政区划失败',
    deleteSuccess: '删除行政区划成功',
    deleteError: '删除行政区划失败',
    loadError: '加载行政区划失败',
    searchError: '搜索行政区划失败'
  },

  // 国家管理（多语言名称）
  country: {
    title: '国家管理',
    create: '创建国家',
    edit: '编辑国家',
    isoCode2: '二位国家码',
    isoCode3: '三位国家码',
    isoCode2Placeholder: '选填，如 CN',
    isoCode3Placeholder: '必填，如 CHN',
    isoCode3Required: '请输入三位国家码',
    isoCode3Len: '三位国家码必须为 3 个字符',
    nameZh: '中文名称',
    nameEn: '英文名称',
    nameZhPlaceholder: '简体中文显示名',
    nameEnPlaceholder: '英文显示名',
    nameZhRequired: '请输入中文名称',
    nameEnRequired: '请输入英文名称',
    localizedName: '名称（当前界面语言）',
    nameKeyword: '名称关键词',
    nameKeywordPlaceholder: '按当前界面语言下的名称模糊搜索',
    listLanguageHint:
      '列表中的「名称」列随界面语言变化：请求会自动携带 languageId，与后台联表 sys_country_description 的语种一致。',
    statusPlaceholder: '状态',
    statusRequired: '请选择状态',
    loadError: '加载国家列表失败',
    createSuccess: '创建国家成功',
    createError: '创建国家失败',
    updateSuccess: '更新国家成功',
    updateError: '更新国家失败'
  },

  // 消息模板管理
  messageTemplate: {
    title: '消息模板管理',
    list: '消息模板列表',
    create: '创建消息模板',
    edit: '编辑消息模板',
    code: '模板编码',
    codePlaceholder: '请输入模板编码，如 ORDER_CREATED_NOTIFY_APPRAISER',
    codeRequired: '请输入模板编码',
    codeLength: '模板编码长度不能超过 100 个字符',
    titleTemplate: '标题模板',
    titleTemplatePlaceholder: '请输入标题模板，可为空',
    contentTemplate: '正文模板',
    contentTemplatePlaceholder: '请输入消息正文模板内容',
    contentTemplateRequired: '请输入正文模板',
    channelType: '渠道类型',
    channelTypeRequired: '请选择渠道类型',
    channelTypeText: 'TIM 文本消息',
    channelTypeCustom: 'TIM 自定义消息',
    enabledPlaceholder: '请选择状态',
    enabledRequired: '请选择状态',
    remark: '备注',
    remarkPlaceholder: '选填，用于说明模板用途或业务场景',
    remarkLength: '备注长度不能超过 255 个字符',
    extJson: '扩展 JSON',
    extJsonPlaceholder: '请输入合法 JSON，例如 {"path":"/order/detail","orderNo":"${orderNo}"}',
    extJsonInvalid: '扩展 JSON 格式不正确，请输入合法 JSON',
    loadError: '加载消息模板列表失败',
    loadDetailError: '加载消息模板详情失败',
    createSuccess: '创建消息模板成功',
    createError: '创建消息模板失败',
    updateSuccess: '更新消息模板成功',
    updateError: '更新消息模板失败'
  },

  // App 移动端菜单管理
  appMenu: {
    title: 'App 菜单管理',
    currentVersion: '当前发布版本',
    publish: '发布菜单',
    publishSuccess: '菜单发布成功',
    publishError: '菜单发布失败',
    preview: '预览菜单',
    previewTitle: '菜单预览',
    previewCustomerId: '用户 ID',
    previewIdentities: '模拟身份',
    previewIdentitiesPlaceholder: '选择要模拟的身份',
    previewLocale: '语言',
    previewRun: '生成预览',
    previewEmpty: '请先运行预览',
    treeTitle: '菜单树',
    detailTitle: '菜单详情',
    createMenu: '新建菜单项',
    editMenu: '编辑菜单项',
    addRoot: '新增根菜单',
    addChild: '新增子菜单',
    loadError: '加载菜单失败',
    code: '菜单编码',
    codePlaceholder: '如 home / circle / service-orders',
    codeRequired: '请输入菜单编码',
    menuZone: '菜单区域',
    menuZoneRequired: '请选择菜单区域',
    defaultName: '默认名称',
    defaultNamePlaceholder: '简体中文默认展示名',
    defaultNameRequired: '请输入默认名称',
    i18nTitle: '多语言名称',
    i18nName: '展示名称',
    i18nNamePlaceholder: '请输入 {locale} 展示名称',
    i18nHint: 'App 端按用户 locale 匹配；未配置的语言回退到默认名称（zh-CN）。',
    showName: '显示菜单名称',
    showIcon: '显示菜单图标',
    iconPath: '未选中图标路径',
    iconPathPlaceholder: '如 assets/menu-icons/tab_home.png',
    iconActivePath: '选中态图标路径',
    iconActivePathPlaceholder: '如 assets/menu-icons/tab_home_active.png',
    iconPathHint: '填写客户端项目内静态资源路径。未选中用 iconPath，当前选中项用 iconActivePath。',
    routeSection: '跳转配置',
    routeType: '跳转类型',
    routeNative: '原生页面',
    routeWebview: 'H5 内嵌页',
    routeAction: '客户端动作',
    routeExternal: '外部链接',
    routeDivider: '分隔线',
    routeTarget: '路由目标',
    routeTargetPlaceholder: '从路由注册表选择',
    routePath: '自定义路径 / URL',
    routePathPlaceholder: '如 https://example.com 或 /custom/path',
    routePathPreview: '解析路径',
    routePathHint: '由路由注册表自动填充，App 端 Router 按 routeTarget 映射 Screen。',
    actionCode: '动作码',
    groupCode: '侧边栏分组',
    groupCodePlaceholder: '选择分组（仅侧边栏）',
    sortOrder: '排序',
    badgeType: '角标类型',
    badgeNone: '无',
    badgeDot: '圆点',
    badgeCount: '数字',
    badgeApi: '角标数据源',
    minAppVersion: '最低 App 版本',
    minAppVersionPlaceholder: '如 1.2.0，留空表示不限制',
    remark: '备注',
    ruleSection: '可见性规则',
    addRule: '添加规则',
    ruleItem: '规则 {index}',
    ruleMode: '规则模式',
    ruleAlways: '始终显示',
    ruleIfHas: '持有身份时显示',
    ruleIfNotHas: '未持有身份时显示',
    ruleIfAny: '持有任一身份时显示',
    ruleIfAll: '持有全部身份时显示',
    identityCodes: '关联身份',
    identityCodesPlaceholder: '选择身份码',
    vipRequired: '需要 VIP',
    routeRegistryTitle: '客户端路由注册表',
    routeRegistryHint: '左侧选择菜单项查看详情；路由注册表定义 App 端 Screen 映射契约。',
    routeRegistryCode: '路由 Code',
    routeRegistryPath: 'Path',
    routeRegistryScreen: '原生 Screen',
    routeRegistryLabel: '说明',
    zone: {
      bottomNav: '底部导航',
      topNav: '顶部导航',
      topNavSub: '三级 Tab',
      sidebar: '侧边栏',
      sidebarUtility: '侧边栏工具栏',
      sidebarSub: '侧边栏下级'
    }
  },

  // 仪表盘
  dashboard: {
    title: '仪表盘',
    totalUsers: '总用户数',
    activeUsers: '活跃用户',
    newUsersToday: '今日新增用户',
    onlineUsers: '在线用户',
    userGrowth: '用户增长',
    userActivity: '用户活动',
    recentActivities: '最近活动',
    userRegistration: '用户注册',
    userLogin: '用户登录',
    profileUpdate: '资料更新',
    userLogout: '用户退出',
    minutesAgo: '分钟前',
    newUserRegistered: '新用户 "{username}" 已注册',
    userLoggedIn: '用户 "{username}" 已登录',
    userUpdatedProfile: '用户 "{username}" 更新了资料',
    userLoggedOut: '用户 "{username}" 已退出'
  },

  // 商家入驻申请
  storeApplication: {
    title: '商家入驻申请审核',
    list: '商家入驻申请列表',
    reviewButtonText: '审核',
    review: '审核商家入驻申请',
    storeName: '商家名称',
    storeNamePlaceholder: '请输入商家名称',
    realName: '姓名',
    realNamePlaceholder: '请输入姓名',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    contactName: '联系人姓名',
    contactPhone: '联系电话',
    province: '省份',
    city: '城市',
    county: '区县',
    address: '详细地址',
    status: '审核状态',
    statusPlaceholder: '请选择审核状态',
    statusPending: '待审核',
    statusApproved: '通过',
    statusRejected: '驳回',
    rejectReason: '驳回原因',
    rejectReasonPlaceholder: '请输入驳回原因（驳回时必填）',
    remark: '审核备注',
    remarkPlaceholder: '请输入审核备注',
    approve: '通过',
    reject: '驳回',
    submittedAt: '提交时间',
    reviewedAt: '审核时间',
    loadError: '加载申请列表失败',
    loadDetailError: '加载申请详情失败',
    reviewSuccess: '审核成功',
    reviewError: '审核失败',
    approveConfirm: '确定要通过该申请吗？',
    rejectConfirm: '确定要驳回该申请吗？',
    rejectReasonRequired: '驳回时必须填写驳回原因',
    certifications: '认证材料',
    certificationType1: '营业执照',
    certificationType2: '烟草证',
    certificationType3: '雪茄销售证',
    certificationType4: '店铺实体照片',
    certificationType5: '法人身份证头像面',
    certificationType6: '法人身份证国徽面',
    longitude: '经度',
    latitude: '纬度',
    customerId: '用户ID'
  },

  // 商品类目管理
  store: {
    // 商家管理
    storeManagement: {
      title: '商家管理',
      list: '商家列表',
      edit: '编辑商家',
      name: '商家名称',
      namePlaceholder: '请输入商家名称',
      nameRequired: '请输入商家名称',
      status: '状态',
      statusPlaceholder: '请选择状态',
      statusNormal: '正常',
      statusDisabled: '禁用',
      province: '省份',
      provincePlaceholder: '请输入省份',
      city: '城市',
      cityPlaceholder: '请输入城市',
      county: '区县',
      countyPlaceholder: '请输入区县',
      address: '详细地址',
      addressPlaceholder: '请输入详细地址',
      addressRequired: '请输入详细地址',
      longitude: '经度',
      longitudePlaceholder: '请输入经度',
      latitude: '纬度',
      latitudePlaceholder: '请输入纬度',
      userId: '用户ID',
      userIdPlaceholder: '请输入用户ID',
      userIdRequired: '请输入用户ID',
      createdAt: '创建时间',
      updatedAt: '更新时间',
      loadError: '加载商家列表失败',
      loadDetailError: '加载商家详情失败',
      updateSuccess: '更新商家成功',
      updateError: '更新商家失败'
    },
    category: {
      title: '商品类目管理',
      list: '类目列表',
      create: '新增类目',
      edit: '编辑类目',
      name: '类目名称',
      description: '类目描述',
      parentCategory: '上级类目',
      image: '类目图片',
      sortOrder: '排序',
      topLevel: '顶级类目',
      unknown: '未知类目',
      namePlaceholder: '请输入类目名称',
      descriptionPlaceholder: '请输入类目描述',
      parentCategoryPlaceholder: '请选择上级类目',
      sortOrderPlaceholder: '请输入排序值',
      nameRequired: '请输入类目名称',
      descriptionRequired: '请输入类目描述',
      sortOrderRequired: '请输入排序值',
      createSuccess: '创建类目成功',
      createError: '创建类目失败',
      updateSuccess: '更新类目成功',
      updateError: '更新类目失败',
      deleteSuccess: '删除类目成功',
      deleteError: '删除类目失败',
      deleteConfirm: '确定要删除类目"{name}"吗？',
      hasChildrenWarning: '该类目下还有子类目，无法删除！请先删除子类目。',
      checkChildrenError: '检查子类目失败',
      loadError: '加载类目失败'
    },
    attribute: {
      title: '商品属性管理',
      list: '属性列表',
      create: '新增属性',
      edit: '编辑属性',
      attributeId: '属性ID',
      name: '属性名称',
      sortOrder: '排序',
      namePlaceholder: '请输入属性名称',
      searchPlaceholder: '搜索属性名称',
      createSuccess: '创建属性成功',
      createError: '创建属性失败',
      updateSuccess: '更新属性成功',
      updateError: '更新属性失败',
      deleteSuccess: '删除属性成功',
      deleteError: '删除属性失败',
      deleteConfirm: '确定要删除这个属性吗？',
      loadError: '加载属性列表失败'
    },
    deliveryTemplate: {
      title: '运费模板',
      list: '运费模板列表',
      create: '新增运费模板',
      createBreadcrumb: '新增模板',
      editBreadcrumb: '编辑模板',
      edit: '编辑运费模板',
      templateName: '模板名称',
      templateNamePlaceholder: '请输入名称',
      shippingOrigin: '发货地区',
      shippingOriginPlaceholder: '请选择发货地区',
      provincePlaceholder: '请选择省份',
      cityPlaceholder: '请选择城市',
      districtPlaceholder: '请选择区县',
      // 运费类型 (oc_delivery_template.freight_type)
      freightType: '运费类型',
      freightTypeStep: '阶梯计价',
      freightTypeFixed: '固定运费',
      freightTypeFree: '商家包邮',
      // 商家包邮场景下的红色服务说明 (Figma 47:215)
      freightTypeFreeWarning: '当前店铺已开通偏远地区物流服务（仅支持新疆），该模板除限售地区外在直邮和中转履约方式下均全国包邮',
      // 计价方式 (oc_delivery_template.valuation)
      pricingMethod: '计价方式',
      byQuantity: '按件数',
      byWeight: '按重量',
      byVolume: '按体积',
      unitPiece: '件',
      unitWeight: 'kg',
      unitVolume: 'm³',
      // 运费计算面板
      shippingCalc: '运费计算',
      shippingCalcDesc: '除指定地区外，其余地区运费采用："默认运费"',
      directRuleTitle: '直邮运费计算规则',
      directRuleHint: '默认运费为兜底规则，未命中指定地区/条件包邮时使用',
      defaultFreight: '默认运费',
      // 固定运费场景下默认运费 label (Figma 47:103)
      defaultFixedFreight: '默认固定运费',
      placeholder: '请输入',
      within: '以内',
      yuan: '元',
      yuanComma: '元，',
      yuanPerOrder: '元/单',
      perAdd: '每增加',
      addFreight: '增加运费',
      comma: '，',
      // 指定地区运费
      areaRuleTitle: '指定地区运费',
      addArea: '添加地区',
      // 指定条件包邮
      freeRuleTitle: '指定条件包邮',
      freeRuleHint: '指定区域设置满X元包邮，满足包邮条件优先按照包邮计算，不满足时按照阶梯价格计算',
      // 固定运费场景下"指定条件包邮"提示文字 (Figma 47:118)
      freeRuleHintFixed: '指定区域设置满X元包邮，满足包邮条件优先按照包邮计算，不满足时按照固定价格计算',
      // 添加地区弹窗
      modalTitleArea: '添加指定地区运费',
      modalTitleFree: '添加指定条件包邮',
      applicableAreas: '适用地区',
      selectAreas: '请选择地区',
      selectAreasRequired: '请至少选择一个地区',
      startStandardLabel: '首{unit}内',
      startFeeLabel: '首费',
      addStandardLabel: '每增加{unit}',
      addFeeLabel: '续费',
      fixedFeeLabel: '固定运费金额',
      // 包邮条件
      freeConditionType: '包邮条件',
      freeCondQty: '满件/满重 ({unit})',
      freeCondAmount: '满金额',
      freeCondBoth: '同时满足',
      freeStandardLabel: '满 {unit} 数量',
      freeAmountLabel: '满金额',
      // 列表汇总文案
      stepFeeSummary: '首{startStandard}{unit}内{startFee}元，每增加{addStandard}{unit}+{addFee}元',
      fixedFeeSummary: '固定 {fee} 元/单',
      freeSummaryQty: '满 {v} {unit} 包邮',
      freeSummaryAmount: '满 {v} 元包邮',
      freeSummaryBoth: '满 {qty} {unit} 且满 {amount} 元包邮',
      // 提示
      fillStepFee: '请完整填写默认运费的阶梯参数',
      fillFixedFee: '请填写固定运费金额',
      fillFreeStandard: '请填写包邮件数/重量/体积阈值',
      fillFreeAmount: '请填写包邮金额阈值',
      // 表单校验
      templateNameRequired: '请输入模板名称',
      shippingOriginRequired: '请选择发货地区',
      freightTypeRequired: '请选择运费类型',
      pricingMethodRequired: '请选择计价方式',
      // 操作结果
      createSuccess: '创建运费模板成功',
      createError: '创建运费模板失败',
      updateSuccess: '更新运费模板成功',
      updateError: '更新运费模板失败',
      deleteSuccess: '删除运费模板成功',
      deleteError: '删除运费模板失败'
    }
  },

  // 登录注册补充
  auth: {
    login: '登录',
    loginTitle: '用户登录',
    registerTitle: '用户注册',
    username: '用户名',
    password: '密码',
    confirmPassword: '确认密码',
    email: '邮箱',
    phone: '手机号',
    captcha: '验证码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    registerSuccess: '注册成功',
    registerFailed: '注册失败',
    logoutSuccess: '退出成功',
    invalidCredentials: '用户名或密码错误',
    invalidCaptcha: '验证码错误',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    emailPlaceholder: '请输入邮箱',
    phonePlaceholder: '请输入手机号',
    captchaPlaceholder: '请输入验证码',
    confirmPasswordPlaceholder: '请确认密码',
    usernameRequired: '请输入用户名',
    passwordRequired: '请输入密码',
    emailRequired: '请输入邮箱',
    phoneRequired: '请输入手机号',
    captchaRequired: '请输入验证码',
    confirmPasswordRequired: '请确认密码',
    passwordMismatch: '两次输入的密码不一致',
    passwordMinLength: '密码至少6个字符',
    usernameLength: '用户名长度在3-20个字符',
    emailInvalid: '请输入有效的邮箱地址',
    phoneInvalid: '请输入有效的手机号',
    noAccount: '还没有账户?',
    hasAccount: '已有账户?',
    registerLink: '注册',
    loginLink: '登录',
    registerSubtitle: '请填写信息进行注册',
    captchaLoadError: '加载验证码失败',
    checkInput: '请检查输入',
    createAccount: '创建账户'
  },

  // 优惠券管理
  coupon: {
    title: '优惠券管理',
    list: '优惠券列表',
    create: '新建优惠券',
    edit: '编辑优惠券',
    name: '名称',
    code: '编码',
    type: '类型',
    discount: '优惠金额',
    total: '消费金额',
    dateStart: '开始时间',
    dateEnd: '截止时间',
    usageTime: '使用时间',
    usesTotal: '发放量 (张)',
    usesCustomer: '每人限领 (张)',
    status: '状态',
    statusPlaceholder: '请选择状态',
    start: '开始',
    end: '结束',
    to: '至',
    productScope: '商品范围',
    basicInfo: '基本信息',
    discountInfo: '优惠信息',
    thresholdAmount: '优惠方式',
    full: '满',
    reduce: '减',
    selectProducts: '选择商品',
    productName: '商品名称',
    productPrice: '商品价格',
    namePlaceholder: '请输入名称',
    codePlaceholder: '请输入优惠券编码',
    dateStartPlaceholder: '开始',
    dateEndPlaceholder: '结束',
    totalPlaceholder: '请输入消费金额',
    discountPlaceholder: '请输入优惠金额',
    usesTotalPlaceholder: '请输入整数',
    usesCustomerPlaceholder: '请选择每人限领数量',
    unlimited: '不限',
    sheets: '张',
    nameRequired: '请输入优惠券名称',
    dateStartRequired: '请选择开始时间',
    dateEndRequired: '请选择截止时间',
    dateRangeRequired: '请选择使用时间',
    nameMaxLength: '名称最多10个字符',
    dateEndBeforeStart: '截止时间不能早于开始时间',
    totalMin: '消费金额不能小于0',
    discountMin: '优惠金额不能小于0',
    discountLessThanTotal: '优惠金额必须小于消费金额',
    usesTotalMin: '发放数量不能小于0',
    usesTotalRange: '发放数量必须在1000-100000之间',
    usesCustomerMin: '每人限领数量不能小于0',
    usesCustomerLessThanTotal: '每人限领数量不能大于发放数量',
    createSuccess: '新建优惠券成功',
    createError: '新建优惠券失败',
    updateSuccess: '更新优惠券成功',
    updateError: '更新优惠券失败',
    deleteSuccess: '删除优惠券成功',
    deleteError: '删除优惠券失败',
    loadProductsError: '加载商品列表失败'
  },

  // 签到奖励规则
  checkinRewardRule: {
    title: '签到奖励规则',
    create: '创建签到奖励规则',
    edit: '编辑签到奖励规则',
    ruleId: '规则ID',
    sourceType: '奖励来源',
    sourceTypePlaceholder: '请选择奖励来源',
    sourceTypeRequired: '奖励来源不能为空',
    rewardType: '奖励类型',
    rewardTypePlaceholder: '请选择奖励类型',
    rewardTypeRequired: '奖励类型不能为空',
    rewardTypePoint: '积分',
    rewardTypeCoupon: '优惠券',
    rewardTypeVirtualCoin: '虚拟币',
    rewardValue: '奖励数值',
    rewardValuePlaceholder: '请输入奖励数值',
    rewardValueRequired: '奖励数值不能为空',
    rewardValueMin: '奖励数值必须大于0',
    continuousDay: '连续签到天数',
    continuousDayPlaceholder: '请输入连续签到天数',
    continuousDayRequired: '连续签到天数不能为空',
    continuousDayMin: '连续签到天数必须大于0',
    rewardHint: '奖励说明',
    rewardHintPlaceholder: '请输入奖励说明文案',
    rewardHintRequired: '奖励说明不能为空',
    enabled: '状态',
    enabledPlaceholder: '请选择状态',
    enabledRequired: '状态不能为空',
    loadError: '加载签到奖励规则列表失败',
    createSuccess: '创建签到奖励规则成功',
    createError: '创建签到奖励规则失败',
    updateSuccess: '更新签到奖励规则成功',
    updateError: '更新签到奖励规则失败'
  },

  // 表情页签
  emoji: {
    title: '表情页签管理',
    list: '表情页签列表',
    create: '创建表情页签',
    edit: '编辑表情页签',
    tabName: '页签名称',
    tabNamePlaceholder: '请输入页签名称',
    tabNameRequired: '页签名称不能为空',
    imagePath: '图片',
    darkImagePath: '暗黑模式图片',
    sortOrder: '排序',
    basicInfo: '基本信息',
    emojis: '表情包',
    addEmoji: '添加表情',
    text: '文本',
    tupleTitle: '标题',
    loadError: '加载表情页签失败',
    createSuccess: '创建表情页签成功',
    createError: '创建表情页签失败',
    updateSuccess: '更新表情页签成功',
    updateError: '更新表情页签失败',
    deleteSuccess: '删除表情页签成功',
    deleteError: '删除表情页签失败',
    // 表情项相关
    tupleCreate: '创建表情项',
    tupleEdit: '编辑表情项',
    tabId: '所属页签ID',
    tabIdPlaceholder: '请输入所属页签ID',
    tabIdRequired: '所属页签ID不能为空',
    tupleType: '类型',
    tupleTypePlaceholder: '请选择类型',
    tupleTypeRequired: '类型不能为空',
    tupleTypeImage: '图片',
    tupleTypeAnimation: '动效',
    textPlaceholder: '请输入文本，如 [symbols188]、[比心]',
    textRequired: '文本不能为空',
    titlePlaceholder: '请输入标题',
    imageName: '图片名称',
    imageNamePlaceholder: '请输入图片名称',
    lottieName: '动图名称',
    lottieNamePlaceholder: '请输入动图名称',
    color: '颜色',
    colorPlaceholder: '请输入颜色值，如 #FBFCFC',
    tupleLoadError: '加载表情项失败',
    tupleCreateSuccess: '创建表情项成功',
    tupleCreateError: '创建表情项失败',
    tupleUpdateSuccess: '更新表情项成功',
    tupleUpdateError: '更新表情项失败',
    tupleDeleteSuccess: '删除表情项成功',
    tupleDeleteError: '删除表情项失败'
  },
  // 订单管理
  order: {
    title: '订单管理',
    list: '订单列表',
    orderNo: '订单编号',
    orderNoPlaceholder: '请输入订单编号',
    fullname: '买家姓名',
    fullnamePlaceholder: '请输入买家姓名',
    status: '订单状态',
    statusPlaceholder: '请选择订单状态',
    total: '订单金额',
    telephone: '联系电话',
    updateStatus: '修改状态',
    detail: '订单详情',
    consign: '发货',
    confirmOrderInfo: '确认订单信息',
    paidDuration: '已支付时长',
    paymentTime: '支付时间',
    latestShippingTime: '最晚发货时间',
    shipAll: '全部发货',
    buyerShippingInfo: '买家收货信息',
    buyerMessage: '买家留言',
    confirmConsignInfo: '确认发货/退货信息',
    myConsignInfo: '我的发货信息',
    myReturnInfo: '我的退货信息',
    selectConsignMethod: '选择发货方式',
    methodSelf: '自己联系物流',
    methodCainiao: '菜鸟裹裹',
    methodNone: '无需物流',
    methodLocal: '同城配送',
    methodStore: '商家配送',
    methodInternational: '国际发货',
    methodLarge: '大件快运',
    addLogisticNo: '添加物流单号',
    selectLogisticCompany: '选择物流公司',
    multiConsign: '多运单发货',
    confirmConsign: '确认并发货',
    consignRemarkPlaceholder: '发货备注，仅自己可见',
    pleaseInputLogisticNo: '请输入物流单号',
    consignSuccess: '发货成功',
    consignFailed: '发货失败',
    printWaybill: '打快递单',
    printWaybillTitle: '打印快递单',
    printWaybillTab: '打印面单',
    startPrint: '开始打印',
    printing: '正在准备打印...',
    printSuccess: '打印成功',
    printFailed: '打印失败'
  },

  sommelierOrder: {
    title: '侍茄师订单列表',
    orderNo: '订单编号',
    orderNoPlaceholder: '请输入订单编号',
    customer: '客户',
    sommelier: '侍茄师',
    phone: '联系电话',
    payPrice: '支付金额',
    payStatus: '支付状态',
    payStatusPaid: '已支付',
    payStatusUnpaid: '未支付',
    status: '业务状态',
    statusNewOrder: '新订单',
    statusPendingService: '待服务',
    statusInService: '服务中',
    statusCompleted: '已完成',
    state: '系统状态',
    statePendingPayment: '待付款',
    statePaid: '已付款',
    stateAccepted: '已接单',
    stateInService: '服务中',
    stateServiceCompleted: '服务完成',
    stateUserCanceled: '用户取消',
    stateSommelierCanceled: '侍茄师取消',
    stateSystemCanceled: '系统取消',
    stateServiceClosed: '服务关闭',
    refundStatus: '退款状态',
    refundStatusNone: '无退款',
    refundStatusRefunding: '退款中',
    refundStatusSuccess: '退款成功',
    refundStatusFailed: '退款失败',
    orderTime: '下单时间',
    startTime: '开始时间',
    endTime: '结束时间',
    loadError: '加载订单列表失败'
  },

  appraiserOrder: {
    title: '鉴茄师订单列表',
    orderNo: '订单编号',
    orderNoPlaceholder: '请输入订单编号',
    customer: '客户',
    appraiser: '鉴茄师',
    cigar: '品牌/系列',
    payAmount: '支付金额',
    state: '系统状态',
    state0: '待付款',
    state1: '已付款',
    state2: '待鉴定',
    state3: '鉴定中',
    state4: '鉴定完成',
    state5: '待复核',
    state6: '用户取消',
    state7: '系统取消',
    state8: '服务关闭',
    status: '业务状态',
    status1: '待鉴定',
    status2: '鉴定中',
    status3: '已鉴定',
    status4: '已完成',
    flags: '标记',
    urgent: '加急',
    onsite: '上门',
    createdAt: '创建时间',
    loadError: '加载鉴茄师订单列表失败'
  },

  sensitiveWord: {
    title: '词库管理',
    word: '敏感词',
    wordPlaceholder: '请输入敏感词',
    level: '级别',
    levelForbidden: '禁止',
    levelReview: '复审',
    levelRateLimit: '限流',
    levelPlaceholder: '请选择级别',
    levelFilterPlaceholder: '全部',
    enabled: '是否启用',
    createdAt: '创建时间',
    keywordPlaceholder: '请输入敏感词关键字搜索',
    create: '新增敏感词',
    edit: '编辑敏感词',
    reload: '重载词典',
    reloadSuccess: '敏感词词典已重新加载',
    reloadError: '词典重载失败',
    deleteConfirm: '确定要删除该敏感词吗？',
    levelRequired: '请选择敏感词级别',
    wordRequired: '敏感词不能为空',
    loadError: '加载敏感词列表失败',
    downloadTemplate: '下载模板',
    exportLexicon: '导出',
    importLexicon: '导入',
    importSuccess: '导入成功：新增 {created} 条，更新 {updated} 条',
    importFailed: '导入失败',
    exportFailed: '导出失败',
    downloadTemplateFailed: '模板下载失败',
    importValidationFailed: '导入校验失败，请检查 Excel 后重试',
    onlyXlsx: '仅支持 .xlsx 格式文件',
    exporting: '正在导出…',
    downloadingTemplate: '正在下载模板…',
    importing: '正在导入…',
  },

  payConfig: {
    title: '支付方式设置',
    subtitle: '配置微信和支付宝等主要支付网关的安全凭证及回调地址',
    loadError: '加载支付配置失败',
    statusEnabled: '已启用',
    statusDisabled: '已停用',
    isDefault: '默认配置',
    channelVersion: '配置版本',
    secretConfigured: '已配置',
    fingerprint: '指纹',
    secretInputPh: '请输入密钥明文（提交后由后端加密存储）',
    secretReplacePh: '已配置，留空表示不修改；如需替换请输入新的密钥明文',
    channel: {
      alipay: '支付宝',
      wechat: '微信支付',
    },
    section: {
      environment: '环境选择',
      basic: '基础配置',
      secret: '密钥配置',
      notify: '通知配置',
    },
    env: {
      production: '正式环境',
      sandbox: '沙箱环境',
    },
    field: {
      environment: '运行环境',
      channelName: '展示名称',
      channelNamePh: '如：支付宝',
      appId: '应用ID',
      appIdPh: '请输入应用ID',
      appIdHint: '支付宝开放平台分配的应用ID',
      merchantNo: '商户号',
      merchantNoPh: '请输入商户号 / 卖家 ID',
      merchantNoHint: '支付宝或微信分配的商户标识',
      apiMethod: '接口标识',
      apiMethodPh: '如：alipay.trade.app.pay',
      signType: '签名类型',
      signTypeHint: '推荐使用更高安全性的 RSA2 算法',
      certMode: '证书模式',
      certModePh: '请选择证书模式',
      timeoutSeconds: '超时时间(秒)',
      timeoutSecondsPh: '请求超时时间',
      icon: '支付图标',
      iconHint: '建议尺寸 64×64px，支持 PNG / SVG 格式',
      iconUpload: '点击或拖拽上传图标',
      merchantPrivateKey: '应用私钥',
      merchantPrivateKeyHint: '商户生成的 RSA2 私钥，请妥善保管，勿泄露',
      aliPublicKey: '支付宝公钥',
      aliPublicKeyPh: '请输入支付宝公钥',
      aliPublicKeyHint: '用于验证支付宝异步通知的签名',
      aliAppCertContent: '应用公钥证书',
      aliPublicCertContent: '支付宝公钥证书',
      aliRootCertContent: '支付宝根证书',
      aliGatewayUrl: '网关地址',
      aliProductCode: '产品码',
      wxApiV3Key: '微信 APIv3 密钥',
      wxApiV3KeyHint: '微信商户平台设置的 APIv3 密钥',
      wxMerchantPrivateKeyHint: '商户 API 证书私钥，请妥善保管',
      wxMchSerialNo: '商户证书序列号',
      wxApiDomain: 'API 域名',
      wxPlatformCertContent: '微信支付平台证书',
      notifyUrl: '异步通知地址',
      notifyUrlHint: '接收支付结果通知的服务器地址，必须外网可访问',
      refundNotifyUrl: '退款回调地址',
      remark: '备注',
    },
    action: {
      save: '保存更改',
      enable: '启用',
      disable: '停用',
      setDefault: '设为默认',
    },
    validate: {
      channelName: '请输入展示名称',
      appId: '请输入 APPID',
      merchantNo: '请输入商户号',
      apiMethod: '请输入接口标识',
    },
  },

  noteReview: {
    pageTitle: '帖子管理',
    detailTitle: '帖子管理详情',
    // Tab 与后端 GET .../sns/note/reviews/list?status= 一一对应：0=全部 1=已发布 2=审核中 3=未通过
    tabAll: '全部帖子',
    tabPublished: '已发布',
    tabPending: '审核中',
    tabRejected: '未通过',
    totalPosts: '共 {total} 个帖子',
    // 顶部筛选栏
    filterTitle: '标题：',
    filterTitlePlaceholder: '搜索标题',
    filterType: '类型：',
    filterCategory: '分类：',
    filterPriority: '审核优先权：',
    filterAllPlaceholder: '全部',
    typeNormal: '图文',
    typeVideo: '视频',
    category0: '推荐',
    category1: '鉴茄',
    category2: '约茄',
    category3: '茄友互助',
    category4: '线下茄吧',
    // 列表项指标
    metricView: '阅读',
    metricLike: '点赞',
    metricComment: '评论',
    metricShare: '分享',
    // 列表项操作
    auditPost: '审核帖子',
    deletePost: '删除帖子',
    deleteConfirm: '确认删除该帖子？',
    deleteSuccess: '删除成功',
    deleteError: '删除失败',
    noReviewYet: '该帖子暂无审核记录',
    // 优先级（数值越大越优先），与后端 NoteReview.Priority 枚举对齐
    priority: '优先级',
    priorityNormal: '普通审核',
    priorityUrgent: '紧急违规',
    autoResult: '自动审核',
    autoResultMiss: '未命中',
    autoResultHit: '命中关键词',
    // 详情页（review.vue）保留 key
    hitWords: '命中敏感词',
    hitWordsEmpty: '无',
    statusPending: '待人工',
    statusApproved: '已通过',
    statusRejected: '不通过',
    noteTitle: '帖子标题',
    customerNickname: '发帖人',
    customerJump: '追溯发帖人',
    auditTime: '审核时间',
    createdAt: '创建时间',
    auditAction: '审核',
    auditApprove: '通过',
    auditReject: '不通过',
    rejectModalTitle: '不通过',
    rejectReason: '原因',
    rejectReasonRequired: '请选择不通过原因',
    rejectRemark: '审核备注',
    rejectRemarkPlaceholder: '请输入备注或从下方常用句中选择',
    remarkTemplateLabel: '常用句',
    remarkTemplatePlaceholder: '选择常用句追加到备注',
    auditApproveConfirm: '确认审核通过该帖子？',
    auditSuccess: '审核成功',
    auditError: '审核失败',
    detailTabContent: '帖子内容',
    detailTabUser: '发帖人',
    description: '正文',
    images: '图片',
    video: '视频',
    videoUnavailable: '无视频',
    backToList: '返回列表',
    loadError: '加载审核列表失败',
    detailLoadError: '加载审核详情失败',
    statisticsLoadError: '加载审核统计失败',
    rejectReasonsLoadError: '加载不通过原因失败',
    remarkTemplatesLoadError: '加载常用句失败',
    auditDetailHeading: '审核帖子详情',
    idLabel: 'ID: {id}',
    sectionAutoReport: '自动检测报告',
    detectStatus: '检测状态',
    detectHitLibrary: '命中敏感词库',
    detectMissLibrary: '未命中敏感词库',
    hitKeywords: '命中关键词',
    manualAudit: '人工审核操作',
    auditConclusion: '审核结论',
    violationTypePick: '违规类型',
    violationTypePickHint: '（必选一项）',
    remarkHint: '请输入具体违规描述，将同步给发布者…',
    commonPhrasesShort: '常用句',
    submitAudit: '提交审核结果',
    auditGuidelineTitle: '审核规范提醒',
    auditGuidelineItem1: '严禁政治敏感、色情低俗内容',
    auditGuidelineItem2: '严禁站外引流及虚假交易信息',
    auditGuidelineItem3: '保护用户隐私，不得泄露个人联系方式',
    auditGuidelineItem4: '维持社区氛围，处理恶意引战及谩骂',
    chooseAuditFirst: '请先选择「通过」或「不通过」',
    auditResultSection: '审核结果',
    postPublishedAt: '发帖时间',
    filterKeyword: '关键字：',
    filterKeywordPlaceholder: '搜索标题、作者',
    filterAuditStatus: '审核状态：',
    previewTitle: '详情预览',
    previewEmpty: '点击左侧帖子查看详情',
    previewSensitiveTip: '系统检测到包含违规敏感词，请尽快处理。',
    previewMoreImages: '+{count} 张图',
    previewOpenFull: '查看完整审核详情',
    previewMetricsTitle: '互动数据',
    statusUnderReview: '审核中',
    statusPublishedShort: '已发布',
    statusUrgentTag: '紧急处理',
    phonePostDetail: '帖子详情',
    phoneProfilePreview: '用户主页',
    phoneFollowed: '已关注',
    phoneFollow: '关注',
    phoneCommentPlaceholder: '说点什么...',
    phoneYashId: '雅莳号: {id}',
    phoneLocation: 'IP属地: {location}',
    phoneUnknownDescription: '记录真实的田园生活，分享每一份自然馈赠。',
    phoneFollowing: '关注',
    phoneFollowers: '粉丝',
    phoneLikesCollections: '获赞与收藏',
    phoneNotes: '笔记',
    phoneCollected: '收藏',
    phoneLiked: '赞过',
    phoneMerchantTag: '商家',
    operationPanel: '操作面板',
    pendingCount: '待审核',
    auditedCount: '已审核',
    autoDetectResult: '自动检测结果',
    cancelBack: '取消返回'
  },
  // 评论审核（列表 comment/index.vue + 详情 comment/review.vue）
  commentReview: {
    pageTitle: '评论审核',
    // 列表 Tab：-1-全部（不过滤）/ 0-待审核 / 1-已通过 / 2-未通过
    tabAll: '全部',
    tabPending: '待审核',
    tabApproved: '已通过',
    tabRejected: '未通过',
    // 筛选
    filterPriority: '审核梯队：',
    filterNoteId: '帖子ID：',
    filterNoteIdPlaceholder: '帖子 ID',
    filterCustomerId: '评论人ID：',
    filterCustomerIdPlaceholder: 'customer_id',
    filterAllPlaceholder: '全部',
    // 优先级（数值越大越优先）
    priority: '优先级',
    priorityNormal: '普通审核',
    priorityUrgent: '紧急违规',
    // 机审决策
    machineDecision: '机审结果',
    machinePass: '机审通过',
    machineSuspect: '机审疑似',
    machineBlock: '机审违规',
    riskLevel: '风险等级',
    hitKeywords: '命中关键词',
    hitWordsEmpty: '无',
    hitLabel: '命中：',
    // 状态
    statusPending: '待审核',
    statusApproved: '已通过',
    statusRejected: '未通过',
    statusUrgentTag: '紧急处理',
    // 列表操作
    auditComment: '审核评论',
    previewTitle: '帖子预览',
    loadError: '加载评论审核列表失败',
    // 详情页
    auditDetailHeading: '审核评论详情',
    idLabel: 'ID: {id}',
    operationPanel: '操作面板',
    pendingCount: '待审核',
    auditedCount: '已审核',
    commentContent: '评论内容',
    autoDetectResult: '自动检测结果',
    manualAudit: '人工审核操作',
    auditConclusion: '审核结论',
    auditApprove: '通过',
    auditReject: '不通过',
    rejectRemark: '审核备注',
    rejectRemarkRequired: '请填写驳回原因（用户可见）',
    remarkHint: '请输入驳回原因，将同步给评论人…',
    commonPhrasesShort: '常用句',
    submitAudit: '提交审核结果',
    chooseAuditFirst: '请先选择「通过」或「不通过」',
    auditResultSection: '审核结果',
    auditSuccess: '审核成功',
    auditError: '审核失败',
    detailLoadError: '加载评论审核详情失败',
    cancelBack: '取消返回',
    // 手机预览导航标题
    phonePostDetail: '帖子详情',
    phoneProfilePreview: '用户主页'
  },
  // 商品发布 (Figma 4-Tab) — 仅作用于 store/product/create.vue
  productCreate: {
    pageTitle: '发布商品',
    refresh: '刷新',
    cancel: '取消',
    submit: '提交',
    submitSuccess: '商品创建成功',
    submitFailed: '商品创建失败',
    backToList: '返回列表',
    tabBasic: '基础信息',
    tabMedia: '图文信息',
    tabPriceStock: '价格库存',
    tabService: '服务与履约',
    sectionBasic: '基础信息',
    sectionMedia: '图文信息',
    sectionPriceStock: '价格库存',
    sectionService: '服务与履约',
    title: '商品标题',
    titlePlaceholder: '请输入商品标题',
    titleRequired: '请输入商品标题',
    titleMaxLength: '商品标题不能超过60个字符',
    category: '商品类目',
    categoryPlaceholder: '请选择商品类目',
    categoryRequired: '请选择商品类目',
    attributes: '类目属性',
    addAttribute: '添加属性',
    attributePlaceholder: '请选择属性',
    attributeValuePlaceholder: '请输入属性值',
    removeAttribute: '删除',
    mainImages: '主图',
    mainImagesHint: '最多 5 张, 建议比例 1:1, 单张 ≤ 5MB',
    mainImagesRequired: '请上传至少一张主图',
    mainVideo: '主图视频',
    mainVideoHint: '可选, 单个文件 ≤ 100MB',
    detailImages: '商详图',
    detailImagesHint: '最多 50 张, 单张 ≤ 5MB',
    fillFromMain: '从主图填入',
    deliveryTimeType: '发货时间',
    deliveryTimeTypeRequired: '请选择发货时间',
    deliveryTimeNextDay: '次日发',
    deliveryTime48h: '48小时',
    deliveryTimeSameDay: '当日发',
    subtractType: '订单库存计数',
    subtractTypeRequired: '请选择订单库存计数方式',
    subtractOnOrder: '下单减库存',
    subtractOnPay: '付款减库存',
    specs: '商品规格',
    addSpecType: '添加规格类型',
    specTypePlaceholder: '请选择规格类型',
    specTypeInputPlaceholder: '请输入规格类型',
    specTypeNameRequired: '请输入规格类型',
    specTypeCreateSuccess: '规格类型创建成功',
    specTypeCreateFailed: '规格类型创建失败',
    addSpecImage: '添加规格图',
    moveDown: '下移',
    moveUp: '上移',
    specValuePlaceholder: '请输入{name}',
    specValueDuplicate: '该规格值已存在',
    specValueCreateFailed: '添加规格值失败',
    customSortOrder: '自定义排序',
    specCount: '规格类型 ({current}/{max})',
    skuTable: '价格与库存',
    skuPrice: '价格',
    skuPricePlaceholder: '请输入',
    skuPriceRequired: '请输入价格',
    skuStock: '现货库存',
    skuStockPlaceholder: '请输入库存',
    skuStockRequired: '请输入库存',
    skuId: 'SKU ID',
    skuBarcode: '条形码',
    skuBarcodePlaceholder: '请输入条形码',
    skuStatus: 'SKU状态',
    skuStatusOn: '已上架',
    skuStatusOff: '已下架',
    deliveryTemplate: '运费模板',
    deliveryTemplatePlaceholder: '请选择运费模板',
    productStatus: '商品状态',
    productStatusOn: '上架',
    productStatusOff: '下架',
    variantsRequired: '至少需要一条 SKU 数据',
    invalidPrice: '请填写有效的 SKU 价格',
    invalidStock: '请填写有效的 SKU 库存'
  },
  productEdit: {
    pageTitle: '编辑商品',
    submit: '保存',
    submitSuccess: '商品更新成功',
    submitFailed: '商品更新失败',
    loadFailed: '加载商品数据失败'
  }
}
